import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';

const Login = () => {
    const { instance } = useMsal();

    useEffect(() => {
        instance
            .handleRedirectPromise()
            .then(() => {
                instance.loginRedirect({
                    scopes: ['user.read'],
                });
            })
            .catch((err) => {
                // Handle error
                console.error(err);
            });
    }, [instance]);
    return null;
};

export default Login;
